import ActivityForm from "../../../components/activity/ActivityForm";

const AddActivity = () => {
  return <ActivityForm />;
};

export default AddActivity;